module.exports = __webpack_public_path__ + "media/img/event/Virtual-Scholarship-Fair-2020-Feature-Layer-03-7448d370e104e1346b313294616283c6.svg";